import { render, staticRenderFns } from "./materialTypeNavigation.vue?vue&type=template&id=717c1729&scoped=true&"
import script from "./materialTypeNavigation.vue?vue&type=script&lang=js&"
export * from "./materialTypeNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c1729",
  null
  
)

export default component.exports